import { useState, useEffect } from 'react'
import { Auth, Hub } from 'aws-amplify'

const useAuthStatus = () => {
  const [loggedIn, setLoggedIn] = useState(false)
  const [checkLogin, setCheckLogin] = useState(true)

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser()
        setLoggedIn(!!user)
      } catch (error) {
        console.error('Auth check err:', error)
        setLoggedIn(false)
      } finally {
        setCheckLogin(false)
      }
    }

    checkAuthStatus()

    const listener = (data) => {
      switch (data.payload.event) {
        case 'signIn':
        case 'signOut':
        case 'tokenRefresh':
          console.log(`Auth event: ${data.payload.event}`)
          checkAuthStatus()
          break
        default:
          break
      }
    }
    Hub.listen('auth', listener)

    return () => Hub.remove('auth', listener)
  }, [])


  return { loggedIn, checkLogin }
}

export default useAuthStatus